import Carrossel from "../Components/Home/Carrossel/Carrossel";
import Porcoes from "../Components/Home/Porcoes/Porcoes";
import Beneficios from "../Components/Home/Beneficios/Beneficios";
import Cards from "../Components/Home/Cards/Cards";
import Cajueiro from "../Components/Home/Cajueiro/Cajueiro";

export default function Home() {
  return (
    <div>
      <Cards />
      <Carrossel />
      <Porcoes />
      <Beneficios />
      <Cajueiro />
    </div>
  );
}
